/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to instruct the system to poll while a backend process completes.
 */
export class PollingWaitCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the message to display while polling.
     */
    getMessage() {
        return this.getOutputByName('message', '');
    }
    /**
     * Gets the polling interval in milliseconds.
     */
    getWaitTime() {
        return Number(this.getOutputByName('waitTime', 0));
    }
}
